import { CampaignStatus } from '@/services/campaigns.service';

const styles: Record<CampaignStatus, string> = {
  DRAFT: 'bg-surface-alt text-text-muted',
  SCHEDULED: 'bg-info/15 text-info',
  RUNNING: 'bg-primary/15 text-primary',
  PAUSED: 'bg-warning/15 text-warning',
  COMPLETED: 'bg-success/15 text-success',
  CANCELLED: 'bg-text-muted/15 text-text-muted',
  FAILED: 'bg-danger/15 text-danger',
};

export const CampaignStatusBadge: React.FC<{ status: CampaignStatus }> = ({ status }) => (
  <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-semibold ${styles[status] ?? 'bg-surface-alt text-text-muted'}`}>{status}</span>
);
